import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import {
  wcStoreApi,
  wcStoreApiReducer,
  wcStoreApiMiddleware,
  wpRestApi,
  wpRestApiReducer,
  wpRestApiMiddleware,
} from "./api";
import productReducer from "../features/product/productSlice";

// Configure store with reducers and middleware
export const store = configureStore({
  reducer: {
    // Add the API reducers as specific slices
    [wcStoreApi.reducerPath]: wcStoreApiReducer,
    [wpRestApi.reducerPath]: wpRestApiReducer,
    // Add other reducers
    product: productReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other RTK Query features
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(wcStoreApiMiddleware, wpRestApiMiddleware),
});

// Set up listeners for RTK Query
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
